/**
 * Adds the aria validation attributes to an element
 *
 * @since <version 3.4.2>
 * @param {string} id The id of the component
 * @param {boolean} valid Whether or not the value of the component is valid.
 * @param {boolean} showValidationState Whether or not the field's state of 'valid' should be displayed.
 * @returns {ValidationAccessibility} The page of data to be displayed
 */
export var validationAccessibility = function (id, valid, showValidationState) {
    return !valid && showValidationState ? { 'aria-describedby': id + '-error-message', 'aria-invalid': true } : {};
};
